import { SEONGNAM_DEFAULT_LOCATION } from '@/shared/lib'

/** 차량 이야기 주변 정비소 기본 위치 (성남시 분당구) */
export const CAR_STORY_NEAREST_PLACE_DEFAULT_LOCATION =
  SEONGNAM_DEFAULT_LOCATION
